export enum LadingCodeStatus {
    Active = 1,
    InActive = -1
}